import { render, staticRenderFns } from "./EventListOwn.vue?vue&type=template&id=022d3aa4&scoped=true&"
import script from "./EventListOwn.vue?vue&type=script&lang=js&"
export * from "./EventListOwn.vue?vue&type=script&lang=js&"
import style0 from "./EventListOwn.vue?vue&type=style&index=0&id=022d3aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d3aa4",
  null
  
)

export default component.exports